import React from "react";
import { Link } from "react-router-dom";

import logoImg from "images/logo.png";
import logoLightImg from "images/logo.png";
import logoNewYear from "images/logo-nationalday.gif";

export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoImg,
  className = "w-20",
}) => {
  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block text-primary-6000 focus:outline-none focus:ring-0 ${className}`}
    >
      {/* <LogoSvgLight />
      <LogoSvg /> */}

      {/* THIS USE FOR MY CLIENT */}
      {/* PLEASE UN COMMENT BELLOW CODE AND USE IT */}
      {img ? (
        <img
          className={`block max-h-24 ${imgLight ? "dark:hidden" : ""}`}
          src={img}
          alt="Ticket Magic Logo"
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img
          className="hidden max-h-12 dark:block"
          src={imgLight}
          alt="Ticket Magic Logo-Light"
        />
      )}
    </Link>
  );
};

export default Logo;
